import stakeIcon from "../images/stakeIcon.png";
import swapGoldBg1 from "../images/swapgoldBg1.svg";
import swapGoldBg2 from "../images/SwapGoldBg2.svg";
import exchangeCoin1 from "../images/exchangeCoin1.svg";
import { FaArrowDown, FaChevronUp } from "react-icons/fa6";
import { Link } from "react-router-dom";

const Stake = () => {
  return (
    <div >
      <section className="max-w-[1400px] mx-auto">
      <div className="flex items-center my-5 ml-10">
        <img className="w-[82px]" src={stakeIcon} alt="Swap Gold" />
        <div className="">
          <h3 className="text-2xl text-yellow-400 font-semibold">
            Stake $SGOLD Token
          </h3>
          <p className="text-lg font-semibold">
            Stake your $SGOLD Tokens and Earn Money{" "}
          </p>
        </div>
      </div>
      <div className="flex flex-col justify-center items-center p-5 relative  w-full h-auto ">
        <img
          className="hidden md:block absolute  left-10 bottom-16  w-[380px]"
          src={swapGoldBg1}
          alt="decor-image"
        />
        <div>
          <Link className="inline-block m-2 px-6 py-3 font-bold text-gray-900 bg-yellow-400 rounded-3xl transition-all duration-300 hover:bg-yellow-300 hover:scale-110 shadow-lg hover:shadow-yellow-500/30 transform origin-center">
            New Position
          </Link>
          <Link to={"/stakePosition"} className="inline-block m-2 px-6 py-3 font-bold text-yellow-400  hover:text-yellow-300 rounded-3xl transition-all duration-300  shadow-lg  transform origin-center">Current Positions</Link>
        </div>
        <div className="w-[100%] md:w-[500px]   relative bg-yellow-200/20 rounded-3xl z-10 backdrop-blur-sm border border-yellow-300 px-3   md:px-5 py-5">
          <h1 className="text-center text-3xl font-bold">
            Buy <span className="text-yellow-400">$SGOLD</span> Token
          </h1>
          <div className="bg-gray-400/20 mt-5 p-3 md:p-5 rounded-3xl">
            <div className="flex justify-between">
              <div className="flex flex-col justify-end items-start">
                <p>You pay</p>
                <h3 className="text-2xl md:text-3xl font font-semibold mt-2">
                  1535
                </h3>
              </div>
              <div className="flex justify-between flex-col items-end">
                <p>Balance: 2500</p>
                <button className="hover:scale-105 transition-all w-auto border-[1px] border-yellow-200 text-sm  bg-yellow-500/5 rounded-3xl mt-2 flex items-center p-2 ">
                  <img
                    className="mx-1"
                    src={exchangeCoin1}
                    alt=" "
                    width={"27px"}
                    height={"27px"}
                  />
                  <p className="">SGOLD</p>
                </button>
              </div>
            </div>
            <div className="flex mt-2">
              <button className="w-[20%] text-center border-[1px] border-yellow-200 text-sm font-light  bg-yellow-400/5 rounded-3xl mt-2 mx-1 p-1 ">
                10%
              </button>
              <button className="w-[20%] text-center border-[1px] border-yellow-200 text-sm font-light bg-yellow-400/5 rounded-3xl mt-2 mx-1 p-2 ">
                25%
              </button>
              <button className="w-[20%] text-center border-[1px] border-yellow-200 text-sm font-light bg-yellow-400/5 rounded-3xl mt-2 mx-1 p-2 ">
                50%
              </button>
              <button className="w-[20%] text-center border-[1px] border-yellow-200 text-sm font-light bg-yellow-400/5 rounded-3xl mt-2 mx-1 p-2 ">
                75%
              </button>
              <button className="w-[20%] text-center border-[1px] border-yellow-200 text-sm font-light  bg-yellow-400/5 rounded-3xl mt-2 mx-1 p-2 ">
                100%
              </button>
            </div>
          </div>
          <div className="bg-yellow-400  w-fit p-2 rounded-full absolute b left-[46%] top-[45%] border-[3px] border-gray-800 ">
            <FaArrowDown className="text-black" />
          </div>
          <div className="bg-gray-400/20 mt-3 p-5 rounded-3xl">
            <div className="flex justify-between">
              <div className="flex flex-col justify-end items-start">
                <p>You Receive</p>
                <h3 className="text-2xl md:text-3xl font font-semibold mt-2">
                  3500
                </h3>
              </div>
              <div className="flex justify-between flex-col items-end">
                <p>Balance: 350</p>
                <button className="w-auto border-[1px] border-yellow-200 text-sm font-semibold bg-yellow-500/5 rounded-3xl mt-2 flex items-center p-2 ">
                 
                  <p className="font-normal">Tokenized Gold</p>
                </button>
              </div>
            </div>
            <div className="flex mt-2">
              <p>Min. receive : 3496.30</p>
            </div>
          </div>
          <div className="">
            <div className="flex items-center justify-center">

            <h3 className="text-yellow-400 text-center mt-3 font-semibold text-lg flex">
              Gold = $2,671.37<span className="text-green-500 text-center flex items-center mx-1"><FaChevronUp/> %0.54</span>
            </h3>
            </div>
            <button className="bg-gradient-to-r from-yellow-400 to-yellow-500 p-3 rounded-3xl w-full mt-3 text-gray-800 font-semibold">
              Connect Wallet
            </button>
          </div>
        </div>

        <img
          className="hidden md:block absolute right-16 top-16 w-[343px]"
          src={swapGoldBg2}
          alt="decor-image"
        />
      </div>
      <div className="flex justify-center mb-8">
        <img className="block md:hidden w-[312px]" src={swapGoldBg2}  alt="decor-image"/>
      </div>
      </section>
    </div>
  );
};

export default Stake;
